import { OPPORTUNITIES_ACTIONS } from "./OPPORTUNITIES_ACTIONS"


export function opportunitiesReducer(state, action) {
  switch (action.type) {
    case OPPORTUNITIES_ACTIONS.SET_OPPORTUNITIES:
      return {
        ...state,
        countries: action.payload.countries,
        pagination: action.payload.pagination,
      }
    case OPPORTUNITIES_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}